export default "__VITE_ASSET__Dqpg6y3s__"